/**
 * 商品企画マスタ画面　企画進捗VOクラス
 */
export class KYMW1300CatalogProgressModel {

  public ProgressWorkNum: string = null;                                        // 工程管理NO
  public MediumType: string = null;                                             // 媒体区分

}
